import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import useIsMobile from "../utilities/useIsMobile";

const SciplayGames = ({ showTitles }: { showTitles: boolean }) => {
  const width = 100;
  const isMobile = useIsMobile();

  const games = {
    GFC: {
      url: "https://www.goldfishslots.com/",
      image: (
        <StaticImage
          src="../images/games/GFC.png"
          alt=""
          quality={40}
          width={width}
        />
      ),
      label: "GFC",
      title: (
        <>
          Gold Fish <br />
          Casino Slots
        </>
      ),
    },
    QHS: {
      url: "https://www.quickhitslots.com/",
      image: (
        <StaticImage
          src="../images/games/QHS.png"
          alt=""
          quality={40}
          width={width}
        />
      ),
      label: "Quick Hit",
      title: (
        <>
          Quick Hit <br />
          Slots
        </>
      ),
    },
    HSC: {
      url: isMobile
        ? "https://app.adjust.com/1huv86ns_1htki50e"
        : "https://apps.facebook.com/hotshotcasino/?source=jackpotparty.com",
      image: (
        <StaticImage
          src="../images/games/HSC.png"
          alt=""
          quality={40}
          width={width}
        />
      ),
      label: "Hot Shot",
      title: (
        <>
          Hot Shot <br />
          Casino
        </>
      ),
    },
    BINGO: {
      url: isMobile
        ? "https://app.adjust.com/1hrkj6xg_1hijl0ww"
        : "https://apps.facebook.com/bingo-showdown/?source=jackpotparty.com",
      image: (
        <StaticImage
          src="../images/games/BINGO.png"
          alt=""
          quality={40}
          width={width}
        />
      ),
      label: "BINGO",
      title: (
        <>
          BINGO
          <br /> Showdown
        </>
      ),
    },
    "88F": {
      url: isMobile
        ? "https://app.adjust.com/1hw8c91l_1hkf7v13"
        : "https://play.google.com/store/apps/details?id=com.ballytechnologies.f88",
      image: (
        <StaticImage
          src="../images/games/88F.png"
          alt=""
          quality={40}
          width={width}
        />
      ),
      label: "88 Fortunes",
      title: (
        <>
          88 Fortunes <br />
          Slots
        </>
      ),
    },
    MS: {
      url: isMobile
        ? "https://app.adjust.com/1hh9da1e_1hzxmq35"
        : "https://apps.facebook.com/monopoly-slots/?source=jackpotparty.com",
      image: (
        <StaticImage
          src="../images/games/MS.png"
          alt=""
          quality={40}
          width={width}
        />
      ),
      label: "MONONPOLY",
      title: (
        <>
          MONONPOLY
          <br /> Slots
        </>
      ),
    },
    BG: {
      url: isMobile
        ? "https://app.adjust.com/1hqrpxs2_1hq8rm5l"
        : "https://apps.facebook.com/cp_backgammon_new/?source=jackpotparty.com",
      image: (
        <StaticImage
          src="../images/games/BG.png"
          alt=""
          quality={40}
          width={width}
        />
      ),
      label: "Backgammon",
      title: (
        <>
          Backgammon
          <br /> Live ™
        </>
      ),
    },
    SPA: {
      url: isMobile
        ? "https://app.adjust.com/1ht7xcvk_1hont5im"
        : "https://apps.apple.com/ph/app/solitaire-pets-fun-card-game/id1354369053?mt=8",
      image: (
        <StaticImage
          src="../images/games/SPA.png"
          alt=""
          quality={40}
          width={width}
        />
      ),
      label: "Solitaire Pets",
      title: (
        <>
          Solitaire Pets <br /> Adventure
        </>
      ),
    },
  };

  return (
    <div className="sciplay-games grid grid-cols-4 xl:flex xl:justify-center xl:space-x-5 xl:items-ceter">
      {Object.keys(games).map((gameKey) => {
        const game = games[gameKey];
        return (
          <div key={gameKey} className="flex flex-col justify-start items-center">
            <a href={game.url} target="_blank" aria-label={game.label}>
              {game.image}
            </a>
            {showTitles && (
              <a
                href={game.url}
                target="_blank"
                className="sciplay-app-title"
                aria-label={game.label}
              >
                {game.title}
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SciplayGames;

